module.exports = __webpack_public_path__ + "img/back-to-top-copy.0ed01ae5.svg";